import { Component, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import Loader from '@/components/Loader/index.vue'

import fetch from '@/helpers/fetch'
import dateHelper from '@/helpers/date'

import Others from './Others/index.vue'

@Component({
	components: {
		Loader,
		Others,
	},
})
export default class Vacations extends Vue {
	tabs = ['CLT', 'Sócios/Associados/PJ']
	activeTab = 'CLT' // Inicia com a tab "Judicial" selecionada

	async switchTab(tab) {
		this.activeTab = tab
		await Vue.nextTick()
	}
}
